// ========================================
// ========== Global Plugins ==============
// ========================================

import Vue from "vue";
import Router from "vue-router";
import * as Plugins from "@/plugins";
import PortalVue from "portal-vue";
Vue.use(Router);
Vue.use(Plugins.SnapSVG);
Vue.use(Plugins.Bootstrap);
Vue.use(Plugins.Icon);
Vue.use(Plugins.Translate);
Vue.use(Plugins.ContextMenu);
Vue.use(Plugins.CompositionAPI);
Vue.use(PortalVue);

// ========================================
// ============== App Init ================
// ========================================

import { router } from '@/router';
import { store } from "@/store";
import { i18n } from "@/i18n";
import App from "./App.vue";

new Vue({
	el: "#app",
	router,
	store,
	i18n,
	components: { App },
	template: "<App/>"
});